import { useState } from 'react';
import type { ReactNode } from 'react';
import { useI18nText } from '@/lib/utils/i18nText';
import { GgcLinkedText } from '@/components/ui/ggc/linked-text';

/** Items beyond this count are hidden behind a "More" toggle. */
const VISIBLE_LIMIT = 15;

/* ── 태그 목록: 항목 > VISIBLE_LIMIT 일 때만 clamp + More 버튼.
 *    그 외에는 모든 항목 + Total 카운트 표시. ── */
export function CollapsibleTagList({ items, renderItem }: {
  items: string[];
  renderItem: (item: string, i: number) => ReactNode;
  /** Deprecated — kept for API back-compat but no longer used. */
  maxLines?: number;
}) {
  const { t } = useI18nText();
  const [expanded, setExpanded] = useState(false);

  const willClamp = items.length > VISIBLE_LIMIT;
  const hiddenCount = willClamp ? items.length - VISIBLE_LIMIT : 0;
  const visible = !expanded && willClamp ? items.slice(0, VISIBLE_LIMIT) : items;

  return (
    <div className="collapsible-tag-list">
      <div className="label-list">
        {visible.map((item, i) => renderItem(item, i))}
      </div>
      {items.length > 0 && (
        <div className="collapsible-tag-footer">
          {willClamp && (
            <>
              <GgcLinkedText onClick={() => setExpanded((p) => !p)} className='cursor-pointer' >
                {expanded
                  ? (
                    <span className='text-[11px] flex gap-1 items-center'>
                      {t('Less', '접기')}
                      <span>
                        <i className='fa fa-angle-up'></i>
                      </span>
                    </span>
                  )
                  : (
                    <span className='text-[11px] flex gap-1 items-center'>
                      {t('More +', '더보기 +')} ({`${hiddenCount}`})
                      <span>
                        <i className='fa fa-angle-down'></i>
                      </span>
                    </span>
                  )}                
              </GgcLinkedText>
            </>
          )}
        </div>
      )}
    </div>
  );
}
